<template>
  <div class="working-wall">
    <header>
      <a-row class="header">
        <a-col :span="3" class="header-right">
          <i @click="$router.go(-1)"></i>
        </a-col>
        <a-col :span="18" class="header-title">
          <span>{{ $t("workingWall.AssignmentBBS") }}</span>
        </a-col>
        <a-col :span="3" class="header-left">
          <i class="catalog" @click="show_catalog"></i>
        </a-col>
      </a-row>
    </header>
    <!-- 目录 -->
    <div class="n-class-slide cur">
      <div class="bg" @click="hide" @touchmove.stop.prevent></div>
      <a href="javascript:" class="class-ctrl cur" @click="show_catalog"></a>
      <div class="n-class-box">
        <div class="class-1" ref="allPart">
          <div class="class-2">
            <a
              href="javascript:"
              class="over-hide"
              :class="0 == currentCD ? 'a_cur' : ''"
              @click="chose_id(first_catalog.resources_id, 0, searchValue)"
              >{{ first_catalog.name }}({{ first_catalog.total_num }})</a
            >
          </div>
          <div class="class-3">
            <div
              v-for="(cl, index) in second_catalog"
              :key="index"
              class="index"
            >
              <div class="line-2"></div>
              <a
                href="javascript:"
                @click="chose_id(cl.resources_id, index, searchValue)"
                class="over-hide"
                :class="(index += 1) == currentCD ? 'a_cur' : ''"
                >{{ cl.name }}({{ cl.total_num }})</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 搜索框 -->
    <div class="search">
      <input
        :placeholder="$t('workingWall.searchTip')"
        v-model="searchValue"
        @keyup.13="press"
      />
      <div class="left-icon"></div>
      <div
        class="right-icon"
        v-show="searchValue.trim() != ''"
        @click="clear"
      ></div>
    </div>
    <!--  -->
    <div class="wall-pos">
      <div class="wall-tabs">
        <div
          class="btn"
          @click="changeTab(3, tab_id, searchValue)"
          :class="tabType == 3 ? 'btned' : ''"
        >
          {{ $t("workingWall.MostThumbsUp") }}
        </div>
        <div
          class="btn"
          @click="changeTab(0, tab_id, searchValue)"
          :class="tabType == 0 ? 'btned' : ''"
        >
          {{ $t("workingWall.Hottest") }}
        </div>
        <div
          class="btn"
          @click="changeTab(1, tab_id, searchValue)"
          :class="tabType == 1 ? 'btned' : ''"
        >
          {{ $t("workingWall.Highestpopularity") }}
        </div>
        <div
          class="btn"
          @click="changeTab(2, tab_id, searchValue)"
          :class="tabType == 2 ? 'btned' : ''"
        >
          {{ $t("workingWall.MostCommented") }}
        </div>
      </div>
    </div>

    <!-- 列表 -->
    <!-- -->
    <mescroll-vue
      ref="mescroll0"
      @init="mescrollInit0"
      :down="getMescrollDown(0)"
      :up="getMescrollUp(0)"
      class="wall-list"
      v-show="tabType == 0"
    >
      <div id="dataList0">
        <div
          class="content"
          v-for="(data, index) in tab0.list"
          :key="index"
          @click.stop="go_pages(data.id, data.file_ext)"
        >
          <div class="line"></div>
          <div :class="num(index, tab0.keyword)"></div>
          <div class="content-title">
            <img
              :src="data.avatar != '' ? data.avatar : defaultImg"
              alt
              class="row-head"
              :class="
                index == 0 && tab0.keyword == ''
                  ? 'row-head-first'
                  : index == 1 && tab0.keyword == ''
                  ? 'row-head-second'
                  : index == 2 && tab0.keyword == ''
                  ? 'row-head-third'
                  : ''
              "
              :onerror="errorImg"
            />
            <div class="row-name">
              <h1>{{ data.username }}</h1>
              <h2>{{ data.created_at }}</h2>
            </div>
            <div class="row-left">
              <div class="comment" @click.stop="go_comment(data.id)">
                <i></i>
                {{ data.comment_num }}
              </div>
              <div
                class="fav"
                :class="data.is_praise == 1 ? 'fav-bg' : ''"
                @click.stop="
                  priased(data.id, data.trainplan_id, index, tabType)
                "
              >
                <i :class="data.is_praise == 0 ? 'unfav' : 'faved'"></i>
                {{ data.praise_num }}
              </div>
            </div>
          </div>
          <div class="content-row">
            <div class="flex-content">
              <div>
                <i :class="type(data.file_ext)"></i>
              </div>
              <h1>{{ data.resources_name }}</h1>
              <div
                :class="
                  data.file_ext == ('zip' || 'rar') ? 'unsopport' : 'supported'
                "
              >
                <h2>{{ $t("workingWall.NotSupported") }}</h2>
              </div>
            </div>
            <div v-if="data.my_file_name" class="file-name">
              附件：{{ data.my_file_name }}
            </div>
          </div>
        </div>
      </div>
    </mescroll-vue>
    <mescroll-vue
      ref="mescroll1"
      @init="mescrollInit1"
      :down="getMescrollDown(1)"
      :up="getMescrollUp(1)"
      class="wall-list"
      v-show="tabType == 1"
    >
      <div id="dataList1">
        <div
          class="content"
          v-for="(data, index) in tab1.list"
          :key="index"
          @click.stop="go_pages(data.id, data.file_ext)"
        >
          <div class="line"></div>
          <div :class="num(index, tab1.keyword)"></div>
          <div class="content-title">
            <img
              :src="data.avatar != '' ? data.avatar : defaultImg"
              alt
              class="row-head"
              :class="
                index == 0 && tab1.keyword == ''
                  ? 'row-head-first'
                  : index == 1 && tab1.keyword == ''
                  ? 'row-head-second'
                  : index == 2 && tab1.keyword == ''
                  ? 'row-head-third'
                  : ''
              "
              :onerror="errorImg"
            />
            <div class="row-name">
              <h1>{{ data.username }}</h1>
              <h2>{{ data.created_at }}</h2>
            </div>
            <div class="row-left">
              <div class="comment" @click.stop="go_comment(data.id)">
                <i></i>
                {{ data.comment_num }}
              </div>
              <div
                class="fav"
                :class="data.is_praise == 1 ? 'fav-bg' : ''"
                @click.stop="
                  priased(data.id, data.trainplan_id, index, tabType)
                "
              >
                <i :class="data.is_praise == 0 ? 'unfav' : 'faved'"></i>
                {{ data.praise_num }}
              </div>
            </div>
          </div>
          <div class="content-row">
            <div class="flex-content">
              <div>
                <i :class="type(data.file_ext)"></i>
              </div>
              <h1>{{ data.resources_name }}</h1>
              <div
                :class="
                  data.file_ext == ('zip' || 'rar') ? 'unsopport' : 'supported'
                "
              >
                <h2>{{ $t("workingWall.NotSupported") }}</h2>
              </div>
            </div>
            <div v-if="data.my_file_name" class="file-name">
              附件：{{ data.my_file_name }}
            </div>
          </div>
        </div>
      </div>
    </mescroll-vue>
    <mescroll-vue
      ref="mescroll2"
      @init="mescrollInit2"
      :down="getMescrollDown(2)"
      :up="getMescrollUp(2)"
      class="wall-list"
      v-show="tabType == 2"
    >
      <div id="dataList2">
        <div
          class="content"
          v-for="(data, index) in tab2.list"
          :key="index"
          @click.stop="go_pages(data.id, data.file_ext)"
        >
          <div class="line"></div>
          <div :class="num(index, tab2.keyword)"></div>
          <div class="content-title">
            <img
              :src="data.avatar != '' ? data.avatar : defaultImg"
              alt
              class="row-head"
              :class="
                index == 0 && tab2.keyword == ''
                  ? 'row-head-first'
                  : index == 1 && tab2.keyword == ''
                  ? 'row-head-second'
                  : index == 2 && tab2.keyword == ''
                  ? 'row-head-third'
                  : ''
              "
              :onerror="errorImg"
            />
            <div class="row-name">
              <h1>{{ data.username }}</h1>
              <h2>{{ data.created_at }}</h2>
            </div>
            <div class="row-left">
              <div class="comment" @click.stop="go_comment(data.id)">
                <i></i>
                {{ data.comment_num }}
              </div>
              <div
                class="fav"
                :class="data.is_praise == 1 ? 'fav-bg' : ''"
                @click.stop="
                  priased(data.id, data.trainplan_id, index, tabType)
                "
              >
                <i :class="data.is_praise == 0 ? 'unfav' : 'faved'"></i>
                {{ data.praise_num }}
              </div>
            </div>
          </div>
          <div class="content-row">
            <div class="flex-content">
              <div>
                <i :class="type(data.file_ext)"></i>
              </div>
              <h1>{{ data.resources_name }}</h1>
              <div
                :class="
                  data.file_ext == ('zip' || 'rar') ? 'unsopport' : 'supported'
                "
              >
                <h2>{{ $t("workingWall.NotSupported") }}</h2>
              </div>
            </div>
            <div v-if="data.my_file_name" class="file-name">
              附件：{{ data.my_file_name }}
            </div>
          </div>
        </div>
      </div>
    </mescroll-vue>
    <mescroll-vue
      ref="mescroll3"
      @init="mescrollInit3"
      :down="getMescrollDown(3)"
      :up="getMescrollUp(3)"
      class="wall-list"
      v-show="tabType == 3"
    >
      <div id="dataList3">
        <div
          class="content"
          v-for="(data, index) in tab3.list"
          :key="index"
          @click.stop="go_pages(data.id, data.file_ext)"
        >
          <div class="line"></div>
          <div :class="num(index, tab3.keyword)"></div>
          <div class="content-title">
            <img
              :src="data.avatar != '' ? data.avatar : defaultImg"
              alt
              class="row-head"
              :class="
                index == 0 && tab3.keyword == ''
                  ? 'row-head-first'
                  : index == 1 && tab3.keyword == ''
                  ? 'row-head-second'
                  : index == 2 && tab3.keyword == ''
                  ? 'row-head-third'
                  : ''
              "
              :onerror="errorImg"
            />
            <div class="row-name">
              <h1>{{ data.username }}</h1>
              <h2>{{ data.created_at }}</h2>
            </div>
            <div class="row-left">
              <div class="comment" @click.stop="go_comment(data.id)">
                <i></i>
                {{ data.comment_num }}
              </div>
              <div
                class="fav"
                :class="data.is_praise == 1 ? 'fav-bg' : ''"
                @click.stop="
                  priased(data.id, data.trainplan_id, index, tabType)
                "
              >
                <i :class="data.is_praise == 0 ? 'unfav' : 'faved'"></i>
                {{ data.praise_num }}
              </div>
            </div>
          </div>
          <div class="content-row">
            <div class="flex-content">
              <div>
                <i :class="type(data.file_ext)"></i>
              </div>
              <h1>{{ data.resources_name }}</h1>
              <div
                :class="
                  data.file_ext == ('zip' || 'rar') ? 'unsopport' : 'supported'
                "
              >
                <h2>{{ $t("workingWall.NotSupported") }}</h2>
              </div>
            </div>
            <div v-if="data.my_file_name" class="file-name">
              附件：{{ data.my_file_name }}
            </div>
          </div>
        </div>
      </div>
    </mescroll-vue>
  </div>
</template>
<script>
import MescrollVue from "mescroll.js/mescroll.vue";
import { mapState } from "vuex";
import defaultImg from "../../assets/img/learning_camp/basic_fc.png";
export default {
  computed: {
    ...mapState({
      tabType: (state) => state.working_wall.tab_type,
      scroll0: (state) => state.working_wall.scroll0,
      scroll1: (state) => state.working_wall.scroll1,
      scroll2: (state) => state.working_wall.scroll2,
      scroll3: (state) => state.working_wall.scroll3,
      praised: (state) => state.working_wall.praised,
      fromid: (state) => state.working_wall.fromid,
      comment_num: (state) => state.working_wall.comment_num,
    }),
  },
  data() {
    return {
      defaultImg,
      errorImg:
        'this.src="' + require("@/assets/img/learning_camp/basic_fc.png") + '"',
      tab0: {
        mescroll: null,
        list: [],
        isListInit: false,
        id: 0,
        tabid: 0,
        keyword: "",
      }, // 培训计划
      tab1: {
        mescroll: null,
        list: [],
        isListInit: false,
        id: 0,
        tabid: 0,
        keyword: "",
      }, // 学习资源
      tab2: {
        mescroll: null,
        list: [],
        isListInit: false,
        id: 0,
        tabid: 0,
        keyword: "",
      }, // 知识汇
      tab3: {
        mescroll: null,
        list: [],
        isListInit: false,
        id: 0,
        tabid: 0,
        keyword: "",
      }, // 直播
      tab_id: 0,
      repeat_praise: true,
      slide: false,
      first_catalog: [],
      second_catalog: [],
      // height: "1.7rem",
      // scrollTop: 0, //记录列表滚动距离
      currentCD: 0,
      searchValue: "",
    };
  },
  watch: {
    $route(to, from) {
      if (to.name == "Index") {
        from.meta.keepAlive = false;
        this.$store.commit("working_wall/tabType", 3); // 切换菜单
      } else {
        // from.meta.keepAlive = true;
      }
    },
  },
  components: {
    MescrollVue,
  },
  beforeRouteLeave(to, from, next) {
    // 如果没有配置回到顶部按钮或isBounce,则beforeRouteLeave不用写
    // let curMescroll = this.$refs["mescroll" + this.tabType]; // 找到当前mescroll的ref,调用子组件mescroll-vue的beforeRouteEnter方法
    // curMescroll && curMescroll.beforeRouteLeave(); // 退出路由时,记录列表滚动的位置,隐藏回到顶部按钮和isBounce的配置

    if (to.query.id != undefined) {
      this.$store.commit("working_wall/fromid", to.query.id);
    } else {
      this.$store.commit("working_wall/fromid", -1);
    }
    next();
  },
  created() {
    // this.$i18n.locale = "zh";
  },
  activated() {
    this.tab0.mescroll.scrollTo(this.scroll0, 0);
    this.tab1.mescroll.scrollTo(this.scroll1, 0);
    this.tab2.mescroll.scrollTo(this.scroll2, 0);
    this.tab3.mescroll.scrollTo(this.scroll3, 0);
    //评论数
    if (this.comment_num != 0) {
      if (this.tab0.list.length != 0) {
        this.tab0.list.forEach((value) => {
          if (this.fromid == value.id) {
            value.comment_num = parseInt(value.comment_num) + this.comment_num;
          }
        });
      }
      if (this.tab1.list.length != 0) {
        this.tab1.list.forEach((value) => {
          if (this.fromid == value.id) {
            value.comment_num = parseInt(value.comment_num) + this.comment_num;
          }
        });
      }
      if (this.tab2.list.length != 0) {
        this.tab2.list.forEach((value) => {
          if (this.fromid == value.id) {
            value.comment_num = parseInt(value.comment_num) + this.comment_num;
          }
        });
      }
      if (this.tab3.list.length != 0) {
        this.tab3.list.forEach((value) => {
          if (this.fromid == value.id) {
            value.comment_num = parseInt(value.comment_num) + this.comment_num;
          }
        });
      }
    }
    //点赞数
    if (this.praised != -1) {
      if (this.praised == 1) {
        if (this.tab0.list.length != 0) {
          this.tab0.list.forEach((value) => {
            // console.log(value);
            if (this.fromid == value.id) {
              // this.$set(value, value.is_praise, 1);
              value.is_praise = 1;
              value.praise_num = parseInt(value.praise_num) + 1;
            }
          });
        }
        if (this.tab1.list.length != 0) {
          this.tab1.list.forEach((value) => {
            // console.log(value);
            if (this.fromid == value.id) {
              // this.$set(value, value.is_praise, 1);
              value.is_praise = 1;
              value.praise_num = parseInt(value.praise_num) + 1;
            }
          });
        }
        if (this.tab2.list.length != 0) {
          this.tab2.list.forEach((value) => {
            // console.log(value);
            if (this.fromid == value.id) {
              // this.$set(value, value.is_praise, 1);
              value.is_praise = 1;
              value.praise_num = parseInt(value.praise_num) + 1;
            }
          });
        }
        if (this.tab3.list.length != 0) {
          this.tab3.list.forEach((value) => {
            // console.log(value);
            if (this.fromid == value.id) {
              // this.$set(value, value.is_praise, 1);
              value.is_praise = 1;
              value.praise_num = parseInt(value.praise_num) + 1;
            }
          });
        }
      } else if (this.praised == 0) {
        if (this.tab0.list.length != 0) {
          this.tab0.list.forEach((value) => {
            // console.log(value);
            if (this.fromid == value.id) {
              // this.$set(value, value.is_praise, 0);
              value.is_praise = 0;
              value.praise_num = parseInt(value.praise_num) - 1;
            }
          });
        }
        if (this.tab1.list.length != 0) {
          this.tab1.list.forEach((value) => {
            // console.log(value);
            if (this.fromid == value.id) {
              // this.$set(value, value.is_praise, 0);
              value.is_praise = 0;
              value.praise_num = parseInt(value.praise_num) - 1;
            }
          });
        }
        if (this.tab2.list.length != 0) {
          this.tab2.list.forEach((value) => {
            // console.log(value);
            if (this.fromid == value.id) {
              // this.$set(value, value.is_praise, 0);
              value.is_praise = 0;
              value.praise_num = parseInt(value.praise_num) - 1;
            }
          });
        }
        if (this.tab3.list.length != 0) {
          this.tab3.list.forEach((value) => {
            // console.log(value);
            if (this.fromid == value.id) {
              // this.$set(value, value.is_praise, 0);
              value.is_praise = 0;
              value.praise_num = parseInt(value.praise_num) - 1;
            }
          });
        }
      }
    }
  },
  mounted() {
    // document.title = this.$t("public.Assignment_BBS");
  },
  methods: {
    clear() {
      this.searchValue = "";
    },
    press() {
      if (this.tabType == 0) {
        this.changeTab(this.tabType, this.tab0.id, this.searchValue);
      } else if (this.tabType == 1) {
        this.changeTab(this.tabType, this.tab1.id, this.searchValue);
      } else if (this.tabType == 2) {
        this.changeTab(this.tabType, this.tab2.id, this.searchValue);
      } else if (this.tabType == 3) {
        this.changeTab(this.tabType, this.tab3.id, this.searchValue);
      }
    },
    show_catalog() {
      this.slide = !this.slide;
      if (this.slide) {
        $(".n-class-slide").show();
        $(".n-class-box").addClass("cur");
        //第一次的时候调接口
        if (this.first_catalog.length == 0) {
          this.get_catalog();
        }
      } else {
        $(".n-class-slide").hide();
        $(".n-class-box").removeClass("cur");
      }
    },
    get_catalog() {
      let url = "index.php/mobile/homework/get-wall-list-select-list";
      let params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
        language: localStorage.getItem("_user_data_language"),
      };
      this.$axios.post(url, params).then((res) => {
        // console.log(res);
        this.first_catalog = res.data.result[0];
        this.second_catalog = res.data.result.slice(1);
        //是否添加touchmove事件
        if (
          $(".class-3").height() >
          $(".class-2").height() * this.first_catalog.total_num
        ) {
          this.$refs.allPart.addEventListener("touchmove", function (e) {
            e.preventDefault();
          });
        }
      });
    },
    hide() {
      this.slide = !this.slide;
      $(".n-class-slide").hide();
    },
    chose_id(cid, cindex, keyword) {
      this.currentCD = cindex;
      // 消失
      this.show_catalog();
      this.tab_id = cid;
      this.changeTab(this.tabType, cid, keyword);
    },
    changeTab(type, id, keyword) {
      this.$store.commit("working_wall/tabType", type); // 切换菜单
      let newTab = this.getTabData(type, id, keyword); // 新转换的列表
      if (!newTab.isListInit) {
        newTab.mescroll.triggerDownScroll(); // 加载列表
      }
    },
    // 获取菜单对应的数据
    getTabData(tabType, id, keyword) {
      // console.log(keyword,this.searchValue);
      if (tabType === 0) {
        this.tab0.id = id;
        if (id != this.tab0.tabid || keyword != this.tab0.keyword) {
          this.tab0.isListInit = false;
          this.tab0.tabid = id;
          this.tab0.keyword = keyword;
        }

        return this.tab0;
      } else if (tabType === 1) {
        this.tab1.id = id;
        if (id != this.tab1.tabid || keyword != this.tab1.keyword) {
          this.tab1.isListInit = false;
          this.tab1.tabid = id;
          this.tab1.keyword = keyword;
        }
        return this.tab1;
      } else if (tabType === 2) {
        this.tab2.id = id;
        if (id != this.tab2.tabid || keyword != this.tab2.keyword) {
          this.tab2.isListInit = false;
          this.tab2.tabid = id;
          this.tab2.keyword = keyword;
        }
        return this.tab2;
      } else if (tabType === 3) {
        this.tab3.id = id;
        if (id != this.tab3.tabid || keyword != this.tab3.keyword) {
          this.tab3.isListInit = false;
          this.tab3.tabid = id;
          this.tab3.keyword = keyword;
        }
        return this.tab3;
      }
    },
    mescrollInit0(mescroll) {
      mescroll.tabType = 0; // 加入标记,便于在回调中取到对应的list
      this.tab0.mescroll = mescroll;
    },
    mescrollInit1(mescroll) {
      mescroll.tabType = 1;
      this.tab1.mescroll = mescroll;
    },
    mescrollInit2(mescroll) {
      mescroll.tabType = 2;
      this.tab2.mescroll = mescroll;
    },
    mescrollInit3(mescroll) {
      mescroll.tabType = 3;
      this.tab3.mescroll = mescroll;
    },
    // 多mescroll的配置,需通过方法获取,保证每个配置是单例
    getMescrollDown(tabType) {
      let isAuto = tabType === this.tabType; // 第一个mescroll传入true,列表自动加载
      return {
        auto: isAuto,
        callback: this.downCallback,
        textInOffset: this.$t("public.pullRefresh"),
        textOutOffset: this.$t("public.releaseRefresh"),
        textLoading: this.$t("public.loadtip"),
      };
    },
    /* 下拉刷新的回调 */
    downCallback(mescroll) {
      // 这里加载你想下拉刷新的数据, 比如刷新tab1的轮播数据
      if (mescroll.tabType === 0) {
        // loadSwiper();
      } else if (mescroll.tabType === 1) {
        // ....
      } else if (mescroll.tabType === 2) {
        // ....
      } else if (mescroll.tabType === 3) {
        // ....
      }
      mescroll.resetUpScroll(); // 触发下拉刷新的回调,加载第一页的数据
    },
    getMescrollUp(tabType) {
      return {
        auto: false,
        htmlLoading: `<p class="upwarp-progress mescroll-rotate"></p><p class="upwarp-tip">${this.$t(
          "public.loadtip"
        )}</p>`,
        callback: this.upCallback, // 上拉回调,此处可简写; 相当于 callback: function (page) { upCallback(page); }
        // noMoreSize: 4, // 如果列表已无数据,可设置列表的总数量要大于半页才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看; 默认5
        page: {
          num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 10, //每页数据条数,默认10
        },
        htmlNodata:
          '<p style="font-size:0.22rem">' +
          this.$t("workingWall.noMoreData") +
          "</p>",
        onScroll: (mescroll, y) => {
          this.$store.commit("working_wall/scroll" + tabType, y); // 切换菜单
        },
      };
    },
    upCallback(page, mescroll) {
      if (mescroll.tabType == 0) {
        //最新发布
        // this.list_type = "createdAt";
        // this.mescroll.resetUpScroll();
        this.tab0.isListInit = true;
        let url = "index.php/mobile/homework/get-wall-list";
        let params = {
          user_id: localStorage.getItem("_user_data_id"),
          company_id: localStorage.getItem("_user_data_company_id"),
          sso_token: localStorage.getItem("_user_data_sso_token"),
          sys_id: localStorage.getItem("_sys_id"),
          language: localStorage.getItem("_user_data_language"),
          order_by: "createdAt",
          resources_id: this.tab0.id,
          keyword: this.tab0.keyword,
          size: page.size,
          page: page.num,
        };
        this.$axios.post(url, params).then((res) => {
          if (res.data.code == 0) {
            if (page.num == 1) {
              this.tab0.list = [];
            }
            this.tab0.list = this.tab0.list.concat(res.data.result.list);
            this.$nextTick(() => {
              mescroll.endByPage(
                res.data.result.num,
                res.data.result.pageCount
              );
            });
          } else {
            if (res.data.code == 10600) {
              this.$router.push({ name: "Login" });
            } else {
              this.$toast(res.data.msg);
            }
          }
        });
      } else if (mescroll.tabType == 1) {
        //人气最高
        this.tab1.isListInit = true;
        let url = "index.php/mobile/homework/get-wall-list";
        let params = {
          user_id: localStorage.getItem("_user_data_id"),
          company_id: localStorage.getItem("_user_data_company_id"),
          sso_token: localStorage.getItem("_user_data_sso_token"),
          sys_id: localStorage.getItem("_sys_id"),
          language: localStorage.getItem("_user_data_language"),
          order_by: "clickNum",
          resources_id: this.tab1.id,
          keyword: this.tab1.keyword,
          size: page.size,
          page: page.num,
        };
        this.$axios.post(url, params).then((res) => {
          if (res.data.code == 0) {
            if (page.num == 1) {
              this.tab1.list = [];
            }
            this.tab1.list = this.tab1.list.concat(res.data.result.list);
            this.$nextTick(() => {
              mescroll.endByPage(
                res.data.result.num,
                res.data.result.pageCount
              );
            });
          } else {
            if (res.data.code == 10600) {
              this.$router.push({ name: "Login" });
            } else {
              this.$toast(res.data.msg);
            }
          }
        });
      } else if (mescroll.tabType == 2) {
        //评论最多
        // this.list_type = "commentNum";
        // this.mescroll.resetUpScroll();
        this.tab2.isListInit = true;
        let url = "index.php/mobile/homework/get-wall-list";
        let params = {
          user_id: localStorage.getItem("_user_data_id"),
          company_id: localStorage.getItem("_user_data_company_id"),
          sso_token: localStorage.getItem("_user_data_sso_token"),
          sys_id: localStorage.getItem("_sys_id"),
          language: localStorage.getItem("_user_data_language"),
          order_by: "commentNum",
          resources_id: this.tab2.id,
          keyword: this.tab2.keyword,
          size: page.size,
          page: page.num,
        };
        this.$axios.post(url, params).then((res) => {
          if (res.data.code == 0) {
            if (page.num == 1) {
              this.tab2.list = [];
            }
            this.tab2.list = this.tab2.list.concat(res.data.result.list);
            this.$nextTick(() => {
              mescroll.endByPage(
                res.data.result.num,
                res.data.result.pageCount
              );
            });
          } else {
            if (res.data.code == 10600) {
              this.$router.push({ name: "Login" });
            } else {
              this.$toast(res.data.msg);
            }
          }
        });
      } else if (mescroll.tabType == 3) {
        //点赞最多
        // this.list_type = "praiseNum";
        // this.mescroll.resetUpScroll();
        this.tab3.isListInit = true;
        let url = "index.php/mobile/homework/get-wall-list";
        let params = {
          user_id: localStorage.getItem("_user_data_id"),
          company_id: localStorage.getItem("_user_data_company_id"),
          sso_token: localStorage.getItem("_user_data_sso_token"),
          sys_id: localStorage.getItem("_sys_id"),
          language: localStorage.getItem("_user_data_language"),
          order_by: "praiseNum",
          resources_id: this.tab3.id,
          keyword: this.tab3.keyword,
          size: page.size,
          page: page.num,
        };
        this.$axios.post(url, params).then((res) => {
          if (res.data.code == 0) {
            if (page.num == 1) {
              this.tab3.list = [];
            }
            this.tab3.list = this.tab3.list.concat(res.data.result.list);
            this.$nextTick(() => {
              mescroll.endByPage(
                res.data.result.num,
                res.data.result.pageCount
              );
            });
          } else {
            if (res.data.code == 10600) {
              this.$router.push({ name: "Login" });
            } else {
              this.$toast(res.data.msg);
            }
          }
        });
      }
    },
    num(index, searchValue) {
      if (index == 0 && searchValue == "") {
        return "one";
      } else if (index == 1 && searchValue == "") {
        return "two";
      } else if (index == 2 && searchValue == "") {
        return "three";
      } else {
        return "";
      }
    },
    type(ext) {
      if (ext == "doc" || ext == "docx") {
        return "word";
      } else if (ext == "ppt" || ext == "pptx") {
        return "ppt";
      } else if (ext == "xls" || ext == "xlsx") {
        return "excel";
      } else if (ext == "pdf") {
        return "pdf";
      } else if (ext == "zip" || ext == "rar") {
        return "zip";
      } else if (
        ext == "mp4" ||
        ext == "avi" ||
        ext == "wmv" ||
        ext == "rmvb" ||
        ext == "flv"
      ) {
        return "audio";
      } else {
        return "txt";
      }
    },
    go_comment(id) {
      this.$router.push({
        path: "/main/commentList",
        query: { id: id, from: "working_wall", tabType: this.tabType },
      });
    },
    priased(id, tid, index, tabType) {
      if (this.repeat_praise) {
        this.repeat_praise = false;
        let url = "index.php/mobile/praise/item";
        let params = {
          user_id: localStorage.getItem("_user_data_id"),
          company_id: localStorage.getItem("_user_data_company_id"),
          sso_token: localStorage.getItem("_user_data_sso_token"),
          sys_id: localStorage.getItem("_sys_id"),
          language: localStorage.getItem("_user_data_language"),
          item: id,
          trainplan_id: tid,
          type: 6,
        };
        this.$axios.post(url, params).then((res) => {
          this.repeat_praise = true;
          if (res.data.code == 0) {
            if (res.data.result.is_praise == 1) {
              if (tabType == 0) {
                this.tab0.list[index].is_praise = 1;
                this.tab0.list[index].praise_num++;
              } else if (tabType == 1) {
                this.tab1.list[index].is_praise = 1;
                this.tab1.list[index].praise_num++;
              } else if (tabType == 2) {
                this.tab2.list[index].is_praise = 1;
                this.tab2.list[index].praise_num++;
              } else if (tabType == 3) {
                this.tab3.list[index].is_praise = 1;
                this.tab3.list[index].praise_num++;
              }
            } else {
              if (tabType == 0) {
                this.tab0.list[index].is_praise = 0;
                if (this.tab0.list[index].praise_num > 0) {
                  this.tab0.list[index].praise_num--;
                } else {
                  this.tab0.list[index].praise_num = 0;
                }
              } else if (tabType == 1) {
                this.tab1.list[index].is_praise = 0;
                if (this.tab1.list[index].praise_num > 0) {
                  this.tab1.list[index].praise_num--;
                } else {
                  this.tab1.list[index].praise_num = 0;
                }
              } else if (tabType == 2) {
                this.tab2.list[index].is_praise = 0;
                if (this.tab2.list[index].praise_num > 0) {
                  this.tab2.list[index].praise_num--;
                } else {
                  this.tab2.list[index].praise_num = 0;
                }
              } else if (tabType == 3) {
                this.tab3.list[index].is_praise = 0;
                if (this.tab3.list[index].praise_num > 0) {
                  this.tab3.list[index].praise_num--;
                } else {
                  this.tab3.list[index].praise_num = 0;
                }
              }
            }
          } else {
            if (res.data.code == 10600) {
              this.$router.push({ name: "Login" });
            } else {
              this.$toast(res.data.msg);
            }
          }
        });
      }
    },
    go_pages(id, ext) {
      if (ext == "doc" || ext == "docx") {
        this.$router.push({
          path: "/main/workingWallDetail",
          query: {
            id: id,
            tabType: this.tabType,
          },
        });
      } else if (ext == "ppt" || ext == "pptx") {
        this.$router.push({
          path: "/main/workingWallDetail",
          query: {
            id: id,
            tabType: this.tabType,
          },
        });
      } else if (ext == "xls" || ext == "xlsx") {
        this.$router.push({
          path: "/main/workingWallDetail",
          query: {
            id: id,
            tabType: this.tabType,
          },
        });
      } else if (ext == "pdf") {
        this.$router.push({
          path: "/main/workingWallDetail",
          query: {
            id: id,
            tabType: this.tabType,
          },
        });
      } else if (ext == "zip" || ext == "rar") {
        this.$toast(this.$t("workingWall.zip"));
      } else if (
        ext == "mp4" ||
        ext == "avi" ||
        ext == "wmv" ||
        ext == "rmvb" ||
        ext == "flv"
      ) {
        this.$router.push({
          path: "/main/workingWallVideo",
          query: {
            id: id,
            from: "working_wall_video",
            tabType: this.tabType,
          },
        });
      } else {
        this.$router.push({
          path: "/main/workingWallDetail",
          query: {
            id: id,
            tabType: this.tabType,
          },
        });
      }
    },
  },
};
</script>
<style scoped lang="less">
.mescroll {
  position: fixed;
  top: 2rem;
}
/*隐藏掉滚动条*/
.mescroll::-webkit-scrollbar {
  display: none;
}
header {
  height: 0.69rem;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 7;
  width: 100%;
  padding: 0.1rem 0.3rem;
  background: #f6f6f6;
  // border-bottom: 0.01rem solid #ddd;
  display: flex;
  align-items: center;
  .header-title {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 0.32rem;
      color: #252631;
    }
    i {
      display: inline-block;
      width: 0.22rem;
      height: 0.03rem;
      background: #999999;
      margin: 0 0.1rem;
    }
  }
  .header-right {
    display: flex;
    align-items: center;
    i {
      display: inline-block;
      width: 0.18rem;
      height: 0.34rem;
      background: url("../../assets/img/facecourse/back.png") no-repeat
        center/contain;
      background-size: 100%;
    }
  }
  .header-left {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .catalog {
      display: inline-block;
      width: 0.4rem;
      height: 0.3rem;
      background: url("../../assets/img/new/menu.png") no-repeat center/contain;
      background-size: 100%;
      vertical-align: middle;
      position: relative;
    }
  }
}
.n-class-slide {
  display: none;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  .bg {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
  }
  .class-ctrl {
    position: absolute;
    width: 0.67rem;
    height: 0.67rem;
    text-align: center;
    line-height: 0.55rem;
    top: 0.05rem;
    right: 0.16rem;
    border-top-left-radius: 0.1rem;
    border-top-right-radius: 0.1rem;
  }
  .class-ctrl.cur {
    background: #005587;
  }

  .class-ctrl.cur:after {
    background-image: url(~@/assets/img/new/menu2.png);
  }
  .class-ctrl:after {
    position: absolute;
    width: 0.4rem;
    height: 0.3rem;
    top: 0.15rem;
    right: 0.14rem;
    background-size: 100% 100%;
    background-image: url(~@/assets/img/new/menu.png);
    content: "";
  }

  .n-class-box {
    position: absolute;
    width: 3.5rem;
    height: 85%;
    // min-height:10rem;
    right: 0;
    top: 0.7rem;
    font-size: 0.25rem;
    overflow: hidden;
  }
  .n-class-box.cur {
    animation: move 0.5s linear;
    animation-fill-mode: forwards;
  }
  @keyframes move {
    0% {
      right: -3.5rem;
    }
    100% {
      right: 0rem;
    }
  }
  .class-1 {
    position: absolute;
    width: 3.5rem;
    height: 100%;
    right: 0;
    top: 0;
    background: #eee;
    border-radius: 0.1rem;
    overflow: scroll;
    .line-2 {
      height: 0.06rem;
      background: #fff;
    }
    .class-2 {
      background: #eee;
      border-radius: 0.1rem;
    }
    .class-3 {
      position: fixed;
      top: 1.5rem;
      bottom: 1.3rem;
      overflow: auto;
    }
    a {
      display: block;
      width: 3.5rem;
      padding: 0 0.55rem;
      height: 0.8rem;
      text-align: center;
      line-height: 0.8rem;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      background: #eee;
      color: #666;
      border-radius: 0.05rem;
    }
    .a_cur {
      background: #005587;
      color: #fff;
    }
  }
}

.working-wall {
  height: 100%;
}
.search {
  background: #f6f6f6;
  text-align: center;
  position: relative;
  input {
    width: 95%;
    height: 0.5rem;
    border: none;
    border-radius: 0.05rem;
    padding-left: 0.5rem;
    font-size: 0.26rem;
  }
  .left-icon {
    position: absolute;
    top: 0.1rem;
    left: 4%;
    width: 0.28rem;
    height: 0.28rem;
    background: url("../../assets/img/daka/search.png") no-repeat center/contain;
    background-size: 100%;
    z-index: 100;
  }
  .right-icon {
    position: absolute;
    top: 0.12rem;
    right: 4%;
    width: 0.28rem;
    height: 0.28rem;
    background: url("../../assets/img/closeicom.png") no-repeat center/contain;
    background-size: 100%;
    z-index: 100;
  }
}
.wall-pos {
  height: 0.8rem;
}
.wall-tabs {
  background: #f6f6f6;
  display: flex;
  margin: 0 auto;
  padding: 0 0.3rem;
  width: 100%;
  position: fixed;
  overflow: auto;
  .btn {
    font-size: 0.26rem;
    padding: 0.2rem 0.3rem;
    white-space: nowrap;
  }
  .btned {
    color: #005587;
    border-bottom: 0.03rem solid #005587;
  }
}
.wall-list {
  height: 100%;
  background: #eee;
  .content {
    .line {
      height: 0.2rem;
    }
    .one {
      height: 0.05rem;
      background-image: linear-gradient(90deg, #ffd47e 0%, #ffec9f 100%),
        linear-gradient(#ffffff, #ffffff);
      background-blend-mode: normal, normal;
    }
    .two {
      height: 0.05rem;
      background-image: linear-gradient(
          90deg,
          #b5c0c6 0%,
          #ccd4d8 38%,
          #e3e7e9 100%
        ),
        linear-gradient(#ffffff, #ffffff);
      background-blend-mode: normal, normal;
    }
    .three {
      height: 0.05rem;
      background-image: linear-gradient(
          90deg,
          #d39e7a 0%,
          #e2b390 38%,
          #f0c7a6 100%
        ),
        linear-gradient(#ffffff, #ffffff);
      background-blend-mode: normal, normal;
    }
    .content-title {
      background: #fff;
      padding: 0.3rem 0.3rem 0 0.3rem;
      display: flex;
      align-items: center;
      .row-head {
        width: 0.55rem;
        height: 0.55rem;
        border-radius: 50%;
        margin-right: 0.1rem;
        pointer-events: none; //防止图片点击放大
      }
      .row-head-first {
        width: 0.8rem;
        height: 0.9rem;
        padding: 0.16rem 0.12rem 0.25rem 0.12rem;
        background: url("../../assets/img/working-wall/top1@2x.png") no-repeat
          center/contain;
        background-size: 100%;
      }
      .row-head-second {
        width: 0.8rem;
        height: 0.9rem;
        padding: 0.16rem 0.12rem 0.25rem 0.12rem;
        background: url("../../assets/img/working-wall/top2@2x.png") no-repeat
          center/contain;
        background-size: 100%;
      }
      .row-head-third {
        width: 0.8rem;
        height: 0.9rem;
        padding: 0.16rem 0.12rem 0.25rem 0.12rem;
        background: url("../../assets/img/working-wall/top3@2x.png") no-repeat
          center/contain;
        background-size: 100%;
      }
      .row-name {
        flex-grow: 2;
        h1 {
          max-width: 4rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        h2 {
          font-size: 0.2rem;
          color: #a9aeaf;
        }
      }
      .row-left {
        display: flex;
        .comment {
          font-size: 0.26rem;
          border-radius: 0.1rem;
          border: 1px solid #ddd;
          min-width: 1rem;
          margin-right: 0.15rem;
          height: 0.5rem;
          line-height: 0.5rem;
          text-align: center;
          i {
            display: inline-block;
            width: 0.27rem;
            height: 0.27rem;
            margin-right: 0.05rem;
            vertical-align: middle;
            background: url("../../assets/img/working-wall/comment@2x.png")
              no-repeat center/contain;
            background-size: 100%;
          }
        }
        .fav {
          border-radius: 0.1rem;
          border: 1px solid #ddd;
          min-width: 1rem;
          font-size: 0.26rem;
          height: 0.5rem;
          line-height: 0.5rem;
          text-align: center;
          i {
            display: inline-block;
            width: 0.27rem;
            height: 0.25rem;
            margin-right: 0.05rem;
          }
          .unfav {
            background: url("../../assets/img/working-wall/fav@2x.png")
              no-repeat center/contain;
            background-size: 100%;
          }
          .faved {
            background: url("../../assets/img/working-wall/faved@2x.png")
              no-repeat center/contain;
            background-size: 100%;
          }
        }
        .fav-bg {
          background: #feefef;
          color: #f75d5d;
        }
      }
    }
    .content-row {
      background: #fff;
      padding: 0.3rem 0 0.3rem 0.3rem;
      .flex-content {
        display: flex;
        align-items: center;

        i {
          display: inline-block;
          width: 0.28rem;
          height: 0.33rem;
          margin-right: 0.15rem;
          vertical-align: middle;
        }
        .txt {
          background: url("../../assets/img/working-wall/txt@2x.png") no-repeat
            center/contain;
          background-size: 100%;
        }
        .word {
          background: url("../../assets/img/working-wall/word@2x.png") no-repeat
            center/contain;
          background-size: 100%;
        }
        .excel {
          background: url("../../assets/img/working-wall/excel@2x.png")
            no-repeat center/contain;
          background-size: 100%;
        }
        .ppt {
          background: url("../../assets/img/working-wall/ppt@2x.png") no-repeat
            center/contain;
          background-size: 100%;
        }
        .pdf {
          background: url("../../assets/img/working-wall/pdf@2x.png") no-repeat
            center/contain;
          background-size: 100%;
        }
        .zip {
          background: url("../../assets/img/working-wall/zip@2x.png") no-repeat
            center/contain;
          background-size: 100%;
        }
        .audio {
          background: url("../../assets/img/working-wall/audio@2x.png")
            no-repeat center/contain;
          background-size: 100%;
        }
        h1 {
          flex-grow: 2;
          font-size: 0.3rem;
        }
        .unsopport {
          padding: 0.06rem 0.06rem 0.06rem 0.14rem;
          border-radius: 0.3rem 0 0 0.3rem;
          background: #feefef;
          h2 {
            font-size: 0.2rem;
            color: #f75d5d;
          }
        }
        .supported {
          display: none;
        }
      }
      .file-name {
        background: #fff;
        height: 0.2rem;
        font-size: 0.26rem;
        padding: 0.2rem 0 0.3rem 0;
      }
    }
  }
}
</style>
